import commonApi from './CommonApi.js';

export default {
    getAll: async (parameter) => {
        return await commonApi().get('/v1/case-law-suggestion/getAll', { params: parameter })
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error)
                return {};
            });
    },
    getById: async (parameters) => {
        return await commonApi().get('/v1/case-law-suggestion/getById', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getForDropdown: async (parameter) => {
        return await commonApi().get('/v1/case-law-suggestion/getForDropdown', { params: parameter })
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error);
                return {};
            });
    },
    getTreeviewSelectItems: async (parameters) => {
        return await commonApi().get('/case-law-status/get-treeview-select-items', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
}